export default "__VITE_ASSET__DxvlQoa5__"